module.exports = __webpack_public_path__ + "img/m-zidingyishezhi.3c37bad8.svg";